/* eslint-disable arrow-body-style */
/* eslint-disable react/jsx-no-literals */
/* eslint-disable consistent-return */
/* eslint-disable no-secrets/no-secrets */
/* eslint-disable security/detect-object-injection */
/* eslint-disable camelcase */
import { Chevron, withModalContext } from '@jutro/components';
import { TranslatorContext, withIntl } from '@jutro/locale';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { DatatableUtil, JobUtil } from '@xengage/gw-portals-util-js';
import { ViewModelForm, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import appConfig from 'app-config';
import { PolicyService, UserService, PolicyChangeService } from 'gw-capability-gateway';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import _, { set } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {
    withValidation,
} from '@xengage/gw-portals-validation-react';
import PolicySummary from "twia-capability-quoteandbind-residential-react/components/PolicySummary/PolicySummary"; 
import TFPAPolicySummary from "tfpa-capability-quoteandbind-residential-react/components/TFPAPolicySummary/PolicySummary";
import TWIACommercialPolicySummary from "twia-capability-quoteandbind-cp-react/components/TWIACommercialPolicySummary/TWIACommercialPolicySummary";
import CommercialPolicySummary from "twia-capability-quoteandbind-cp-react/components/CommercialPolicySummary/CommercialPolicySummary";
import { PrivacyDisclosure } from 'twia-capability-policy-react';
import { TFPARenewalRequalSummary } from "tfpa-capability-renewal-common-react"
import { ENTQuestionSetComponent as QuestionSetComponent_Ext } from 'ent-capability-quoteandbind-questionsets-ui/index.js';
import CoveragesIterableComponent from '../../Components/CoveragesIterableComponent/CoveragesIterableComponent';
import gatewayMessages from '../../gateway.messages';
import Cancellation from '../../../ent-capability-gateway-react/Policies/Cancellation/Cancellation';
import ChangePolicy from '../ChangePolicy/ChangePolicy';
import PolicyDwellingInfo from './ho/PolicyDwellingInfo/PolicyDwellingInfo';
import PolicyVehiclesDriversInfo from './pa/PolicyVehiclesDriversInfo/PolicyVehiclesDriversInfo';
import messages from './Summary.messages';
import metadata from './Summary.metadata.json5';
import styles from './Summary.module.scss';

import { Link } from '@jutro/router';

function getCell(items, index, property) {
    return items[property.id];
}

function transactionTypeIsViewableInXCenter(transaction) {
    return (
        transaction.type.toLowerCase() !== 'reinstatement' &&
        transaction.type.toLowerCase() !== 'rewrite'
    );
}

function canUserOpenJobInXCenter(transaction) {
    return (
        transaction.canUserView &&
        transactionTypeIsViewableInXCenter(transaction)
    );
}

class Summary extends Component {
    static propTypes = {
        model: PropTypes.shape({
            paymentMethod: PropTypes.string,
            bankAccountData: PropTypes.shape({}),
            creditCardData: PropTypes.shape({}),
        }),
        viewModelService: PropTypes.shape({
            create: PropTypes.func,
        }).isRequired,
        fromAccountLanding: PropTypes.shape({
            policyDetailsData: PropTypes.shape({
                policyResponse: PropTypes.shape({
                    policyNumber: PropTypes.string,
                }),
            }),
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func,
        }).isRequired,
        authHeader: PropTypes.shape({}).isRequired,
        intl: PropTypes.func.isRequired,
    };

    static contextType = TranslatorContext;

    state = {
        policyData: '',
        disableCancelLink: true,
        showRequalQuestionSet: true,
        showtfpaRequalQuestionSet:  true,
        disableChangePolicyLink: true,
        showPrivacyDisclosure: false,
        policyTransactionData: [],
        policyTransactionStatusValues: [],
        selectedTransactionStatus: 'all',
        searchTransactionKeyword: undefined,
        canAdvanceCancellation: false,
        canEditPolicy: false,
        policyDetailsData : {},
        lobData_TWIA:{},
        policyTransactionDetails:{},
        questionSetVM: {},
        questionSetVM_tfpa: {},
        questionset_tfpa: [],
        showErrors: false,
    };

    componentDidMount() {
        this.hasAdvanceCancellationPermission();
        this.hasEditPolicyPermission();
        this.setPolicyCoveragesDetails();
        this.getPolicyTransactions();
        // this.getResponse();
        this.getLobData_TWIA();
    };

    setPolicyCoveragesDetails = () => {
        const {
            fromAccountLanding: { policyDetailsData },
        } = this.props;
        const policyData = _.cloneDeep(policyDetailsData.policyResponse);

        this.setState({ policyData });
    };

    getPolicyTransactions = async () => {
        const { authHeader, fromAccountLanding } = this.props;

        const policyNumber = _.get(
            fromAccountLanding,
            'policyDetailsData.policyResponse.policyNumber'
        );
        const transactionResponse =
            await PolicyService.getPolicyTransactionsForPolicy(
                policyNumber,
                authHeader
            );

        this.getMappedTransactionData(transactionResponse);
        this.setState({policyTransactionDetails:transactionResponse})

        const policyTransactionStatusValues = this.getPolicyTransactionStatus();

        this.setState({
            transactionResponse,
            policyTransactionStatusValues,
            selectedTransactionStatus: policyTransactionStatusValues[0].code,
        });
    };

    getFormattedCurrency = (premiumAmount, index) => (
            <CurrencyField
                id={`currency${index}`}
                value={premiumAmount}
                readOnly
                hideLabel
                showOptional={false}
                className={styles.currencyStyle}
            />
        );

    getMappedTransactionData = (policyTransactionResponse, filter) => {
        const selectedStatus = _.get(filter, 'selectedTransactionStatus');
        const searchKeyword = _.get(filter, 'searchTransactionKeyword');
        const transactionData = _.cloneDeep(policyTransactionResponse);

        let policyTransactionData = transactionData
            .map((policy, index) => ({
                    jobNumber: policy.jobNumber,
                    status: policy.status,
                    displayType: policy.displayType,
                    policyDisplayStatus: policy.policyDisplayStatus,
                    totalPremium: this.getFormattedCurrency(
                        policy.totalCost_TWIA, // DE19160
                        index
                    ),
                    policyEffectiveDate: policy.policyEffectiveDate,
                    canUserView: policy.canUserView,
                    type: policy.type,
                }))
            .sort((a, b) => (
                    new Date(b.policyEffectiveDate).getTime() -
                    new Date(a.policyEffectiveDate).getTime()
                ));

        if (selectedStatus && selectedStatus !== 'all') {
            policyTransactionData = _.filter(
                policyTransactionData,
                transaction => transaction.status === selectedStatus
            );
        }

        if (searchKeyword) {
            policyTransactionData = this.getSearchFilterValues(
                policyTransactionData,
                searchKeyword
            );
        }

        this.setState({
            policyTransactionData,
        });
    };

    hasAdvanceCancellationPermission = () => {
        const { authHeader } = this.props;
        const permissionDTO = {
            permission: 'advancecancellation',
        };

        UserService.hasUserSystemPermission(permissionDTO, authHeader).then(
            canAdvanceCancellation => {
                this.setState({ canAdvanceCancellation });
            }
        );
    };

    hasEditPolicyPermission = () => {
        const { authHeader } = this.props;
        const permissionDTO = {
            permission: 'editpolchange',
        };

        UserService.hasUserSystemPermission(permissionDTO, authHeader).then(
            canEditPolicy => this.setState({ canEditPolicy })
        );
    };

    getSearchFilterValues = (transactionData, keyword) => {
        const lowerCaseFilterValue = keyword.toLocaleLowerCase();

        return _.filter(transactionData, res => Object.keys(res).some(
                key =>
                    typeof res[key] === 'string' &&
                    res[key].toLocaleLowerCase().includes(lowerCaseFilterValue)
            ));
    };

    getJobNumberLink = (item, index, property) => {
        if (canUserOpenJobInXCenter(item)) {
            if (this.showOpenJobInXCenter(item)) {
                return (
                    <Link
                        href="/"
                        onClick={() => JobUtil.openJobInXCenter(item.jobNumber)}
                        className={styles.jobNumberColumnLink}
                    >
                        {item[property.id]}
                    </Link>
                );
            }
            
            if(item.type === 'Renewal' && this.props.authUserData?.associationName_TWIA ==='tfpa'){
                return (
                    <Link
                        to={`/policy-job-details/${item.jobNumber}`}
                        className={styles.jobNumberColumnLink}
                    >
                        {item[property.id]}
                    </Link>
                );
            }

            return (
                <Link
                    to={JobUtil.getJobDetailURLByJobType(
                        item.type,
                        item.jobNumber
                    )}
                    className={styles.jobNumberColumnLink}
                >
                    {item[property.id]}
                </Link>
            );
        }

        return <span>{item.jobNumber}</span>;
    };

    showOpenJobInXCenter = item => (
            item.type !== 'Submission' &&
            item.type !== 'PolicyChange' &&
            item.type !== 'Cancellation' &&
            item.type !== 'Renewal'
        );

    // US26979
    onChangePolicy = async () => {
        const { policyData } = this.state;
        const { fromAccountLanding, history,authUserData } = this.props;
        const policyNumber = _.get(
            fromAccountLanding,
            'policyDetailsData.policyResponse.policyNumber'
        );
        const { lobEndorsementURL, endorsementProducts } = appConfig;
        const isTFPA = authUserData?.associationName_TWIA === 'tfpa';
        const productCode = _.get(policyData, 'product.productCode');
        const isHomeowners = productCode === 'Homeowners';
        const endorsementURL = isTFPA && isHomeowners ? lobEndorsementURL['HomeownersTFPA'] : lobEndorsementURL[productCode];
       
        if (!_.isEmpty(lobEndorsementURL[productCode])) {
            const redirectLobPath = endorsementURL;

            history.push(redirectLobPath, {
                policyNumber,
                landingFrom: 'quoteSummary',
            });
        } else {
            this.setState({ disableChangePolicyLink: false });
        }
    };

    getJobNumber = async policyNumber => {
        const { authHeader } = this.props;
        const renewalVM = await PolicyService.createNewPolicyRenewalTransaction(
            [policyNumber],
            authHeader
        );

        return _.get(renewalVM, 'jobNumber');
    };

    onRenewalPolicy = async () => {
        const { fromAccountLanding, history } = this.props;
        const { lobRenewalURL } = appConfig;
        const policy = _.get(
            fromAccountLanding,
            'policyDetailsData.policyResponse'
        );
        const policyNumber = _.get(policy, 'policyNumber');
        const lobCode = _.get(
            policy,
            'product.productCode'
        );
        const jobNumber = await this.getJobNumber(policyNumber);

        if (!_.isEmpty(lobRenewalURL[lobCode])) {
            history.push(lobRenewalURL[lobCode], { jobNumber });
        } else {
            JobUtil.openJobInXCenter(jobNumber);
        }
    };

    handleRequalButtonClick = () => {
        const { policyData } = this.state;
        if(policyData.reQualificationNeeded_TFPA ){
            this.setState({ showtfpaRequalQuestionSet : false});
        } else {
            this.setState({ showRequalQuestionSet: false });
        }
        this.setState({ disableCancelLink: false });
        this.setState({ disableChangePolicyLink: false });
    }

    handlePrivacyPolicyClick = () => {
        const { showPrivacyDisclosure: currentPrivacyDisclosureState } = this.state;

        this.setState({ showPrivacyDisclosure: !currentPrivacyDisclosureState });  
    }

    errMsgParser = (err) => {
        const errExpr = /error:/;
        const errMsgExpr = /^entity.\w*\/(.*)/;
        if (err && _.has(err, 'baseError')) {
          const messages = [];
          const retMsg = err.baseError;
          const errMsgs = retMsg.split(errExpr);
          errMsgs.forEach((msg) => {
            if (errMsgExpr.test(msg)) {
              const xx = errMsgExpr.exec(msg);
              messages.push(_.last(xx));
            } 
            
          });
          return _.uniq(messages).join('\n\n\n');
        }
      };

    onAddrequalTWIA = () => {
        const submitting = false;
        const { policyData } = this.state;
        const { authHeader } = this.props
        const questionSet = _.get(policyData, 'latestPeriod.requalificationDTO_TWIA.reQualQuestionSet_TWIA')
        const questionArr = []
        questionArr.push(questionSet)
        const result = PolicyChangeService.updatePolicyPeriodReQualificationQuestions_TWIA(policyData.policyNumber, questionArr, submitting, authHeader )
        .then(
            (res) => {
                _.set(policyData, 'latestPeriod.requalificationDTO_TWIA.reQualQuestionSet_TWIA', res.reQualQuestionSet_TWIA)
                this.setState({ policyData });
            } 
        ) 
    }

    onRequalSubmit = () => {
        const { policyData } = this.state;
        const { authHeader, modalContext, viewModelService, isComponentValid } = this.props
        const submitting = true;
        const policyNumber = policyData.policyNumber
        const redirectClaimsPath = `/policies/${policyNumber}/summary`;
        const questionSet = _.get(policyData, 'latestPeriod.requalificationDTO_TWIA.reQualQuestionSet_TWIA')
        const questionArr = []
        questionArr.push(questionSet)
        if(!isComponentValid) {
            this.setState({showErrors: !isComponentValid})
            return
        }
        
        const result = PolicyChangeService.updatePolicyPeriodReQualificationQuestions_TWIA(policyData.policyNumber, questionArr, submitting, authHeader )
        .then(
        () => {
            modalContext.showAlert({
                    title: messages.requalSubmittedTitle,
                    message: messages.requalSubtitle,
                    status: 'info',
                    icon: 'mi-error-outline',
                    confirmButtonText: messages.doneButton
                }).then( () => {
                    window.location.href = redirectClaimsPath;
                })
            } 
        ).catch(error => {
            modalContext.showAlert({
                title: messages.requalificationQuestionErrorMsg,
                message: error.baseError === "ErrorCode: -32603-INTERNAL_ERROR ErrorMessage: error:entity.TermAnswer_Ext/The applicant must have been denied coverage by at least one insurance company in the private market actively offering windstorm coverage in TWIA’s coverage area for this property to be eligible for coverage."
                    ? messages.requalificationOneInsuranceMsg :
                    this.errMsgParser(error), // DE17615
                className: styles.jut__ModalNext__mod,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: messages.doneButton
            }).then( () => {
                window.location.href = redirectClaimsPath;
            })
        })  
    }

    handleCancelClick = () => {
        const { policyData } = this.state;
        const policyNumber = policyData.policyNumber
        const redirectClaimsPath = `/policies/${policyNumber}/summary`;
        window.location.href = redirectClaimsPath;
    }

    handleValueChange = (value, path, code) => {
        const { policyData } = this.state;
        if(code == "TWIA_Res_Upgraded" || code == "TWIA_Res_Located_Above_3rdFloor") {
            this.onAddrequalTWIA();
        }
        this.setState({policyData})
    }

    handleCancelButtonClick = () => {
        this.setState({ disableCancelLink: false });
    };

    onDoNotCancel = () => {
        this.setState({ disableCancelLink: true });
    };

    onDoNotChangePolicy = () => {
        this.setState({ disableChangePolicyLink: true });
    };

    getResponse = async () => {
        const { authHeader, fromAccountLanding } = this.props;
        const policyNumber = _.get(
            fromAccountLanding,
            'policyDetailsData.policyResponse.policyNumber'
        );
        const result = await PolicyService.getPolicy(policyNumber,authHeader);

        return result;
    };

    getLobData_TWIA = async () => {
        const poliyDetails = await this.getResponse();

        this.setState({ policyDetailsData: poliyDetails })

        if (this.props.authUserData.associationName_TWIA !== 'tfpa') {
            const result = await PolicyService.getLobData_TWIA(poliyDetails.latestPeriod.publicID, this.props.authHeader);

            this.setState({ lobData_TWIA: result });
            
            return result
        }
    }

    getHeaderSection = title => isOpen => (
            <React.Fragment>
                <Chevron isOpen={isOpen} />
                <h2
                    className={`${styles.title} ${styles.gwOverrideDefaultMargin}`}
                >
                    {title}
                </h2>
            </React.Fragment>
        );

    isGeneralCoverage = () => {
        const { policyData } = this.state;

        return (
            [
                'PersonalAuto',
                'Homeowners',
                'HOPHomeowners',
                'homeowners',
                'HomeownersLine_HOE',
            ].indexOf(policyData.product.productCode) === -1
        );
    };

    getPolicyTransactionStatus = () => [
            {
                code: 'all',
                name: gatewayMessages.all,
            },
            {
                code: 'Draft',
                name: {
                    id: 'typekey.PolicyPeriodStatus.Draft',
                    defaultMessage: 'Draft',
                },
            },
        ];

    handleFilterValueChange = value => {
        const { transactionResponse, searchTransactionKeyword } = this.state;

        this.setState({ selectedTransactionStatus: value });
        this.getMappedTransactionData(transactionResponse, {
            selectedTransactionStatus: value,
            searchTransactionKeyword,
        });
    };

    handleSearchValueChange = value => {
        const { transactionResponse, selectedTransactionStatus } = this.state;

        this.setState({ searchTransactionKeyword: value });
        this.getMappedTransactionData(transactionResponse, {
            searchTransactionKeyword: value,
            selectedTransactionStatus,
        });
    };

    formatTitleTypekey = (msg) => {
        const translator = this.context;
        return translator({id: `questionkey.QuestionSet_${msg}.Name`})
    };

    generateOverrides = () => {
        const { policyData } = this.state;
        const overrides = policyData.coverables.map((coverable, i) => ({
                [`namesGrid${i}`]: {
                    visible: !_.isEmpty(coverable.coverages),
                },
            }));

        return Object.assign({}, ...overrides);
    };

    render() {
        const {
            policyData,
            disableCancelLink,
            showRequalQuestionSet,
            showPrivacyDisclosure,
            showtfpaRequalQuestionSet,
            policyTransactionData,
            policyTransactionStatusValues,
            selectedTransactionStatus,
            searchTransactionKeyword,
            disableChangePolicyLink,
            canAdvanceCancellation,
            canEditPolicy,
            policyDetailsData,
            lobData_TWIA,
            policyTransactionDetails,
            showErrors,
        } = this.state;
        const { authHeader, history, fromAccountLanding, setComponentValidation, 
            isComponentValid } = this.props;
        const policyNumber = _.get(
            fromAccountLanding,
            'policyDetailsData.policyResponse.policyNumber'
        );
        const productCode = _.get(policyData, 'product.productCode');

        if (_.isEmpty(policyData)) {
            return null;
        }

        const translator = this.context;
        const preRenewalDirection = _.get(
            fromAccountLanding,
            'policyDetailsData.policyResponse.latestPeriod.preRenewalDirection'
        );

        const getPolicyTypeValue = () => {
            return <p>Policy Type&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <b>{`${policyData?.latestPeriod?.policyType_TWIA}`}</b>
            </p>
        };
        
        const overrides = {
            summaryPolicyTransactionsTableGrid: {
                data: policyTransactionData,
            },
            coveragesSectionContainer: {
                visible: this.isGeneralCoverage(),
            },
            coveragesSection: {
                renderHeader: this.getHeaderSection(
                    translator(messages.Coverages)
                ),
            },
            generalQuestionSet: {
                path: 'latestPeriod.requalificationDTO_TWIA.reQualQuestionSet_TWIA',
                title: this.formatTitleTypekey(_.get(policyData, `latestPeriod.requalificationDTO_TWIA.reQualQuestionSet_TWIA.code`)),
                onValueChange: this.handleValueChange,
                onValidate: setComponentValidation,
                showErrors
            },
            requalTab: {
                visible: !showRequalQuestionSet,
            },
            addRequalButton: {
                visible: (showRequalQuestionSet && showtfpaRequalQuestionSet) && (policyData.latestPeriod?.requalificationDTO_TWIA?.requalNotSubmitted_TWIA == true || policyData.requalNotSubmitted_TFPA == true),
            },
            dataDiv: {
                visible: showRequalQuestionSet && showtfpaRequalQuestionSet,
            },
            cancellationContacts: {
                visible: !disableCancelLink && disableChangePolicyLink,
                history,
                authHeader,
                policyNumber,
                policyData: _.get(
                    fromAccountLanding,
                    'policyDetailsData.policyResponse'
                ),
            },
            changePolicyContacts: {
                visible: !disableChangePolicyLink && disableCancelLink,
                history,
                authHeader,
                policyNumber,
                policyData: _.get(
                    fromAccountLanding,
                    'policyDetailsData.policyResponse'
                ),
            },
            changePolicyButtonId: {
                disabled: !disableCancelLink || !disableChangePolicyLink,
                visible:
                    !policyData.latestPeriod.canceled &&
                    policyData.latestPeriod.canChange &&
                    canEditPolicy, //DE17181
            },
            renewPolicyButtonId: {
                disabled: !disableCancelLink || !disableChangePolicyLink,
                visible: false // !policyData.latestPeriod.canceled && policyData.latestPeriod.canRenew,
                    
            },
            // DE16923
            cancelPolicyButtonId: {
                disabled: !disableCancelLink || !disableChangePolicyLink,
                visible:this.props.authUserData?.associationName_TWIA!=='tfpa'?
                policyData.latestPeriod.displayStatus !== 'Expired' && //DE17064
                    !policyData.latestPeriod.canceled &&
                    policyData.latestPeriod.canCancel &&
                    canAdvanceCancellation : false ,
            },
            privacyButtonContainer:{
                visible:this.props.authUserData?.associationName_TWIA!=='tfpa'
            },
            privacyDisclosure: {
                visible: this.props.authUserData?.associationName_TWIA!=='tfpa' && showPrivacyDisclosure,
                privacyOptOut_TWIA: _.get(policyDetailsData,'privacyOptOut_TWIA')
            },
            policyVehicleInfo: {
                visible: policyData.product.productCode === 'PersonalAuto',
                // value: policyData.lobs.personalAuto,
            },
            policyHouseOwnersInfo: {
                visible:
                    productCode === 'Homeowners' ||
                    productCode === 'HOPHomeowners' ||
                    productCode === 'homeowners' ||
                    productCode === 'HomeownersLine_HOE',
                // value: policyData.lobs.homeOwners,
            },
            policyTransactionStatus: {
                availableValues: policyTransactionStatusValues,
                value: selectedTransactionStatus,
            },
            searchFilter: {
                value: searchTransactionKeyword,
            },
            preRenewalDirectionValueId: {
                value: !_.isNil(preRenewalDirection)
                    ? [preRenewalDirection]
                    : translator(
                          messages.SummaryDetailsPreRenewalDirectionNone
                      ),
            },
            producerOfRecordValueId: {
                value: `${_.get(
                    fromAccountLanding,
                    'policyDetailsData.policyResponse.latestPeriod.producerCodeOfRecordOrg'
                )}(${_.get(
                    fromAccountLanding,
                    'policyDetailsData.policyResponse.latestPeriod.producerCodeOfRecord'
                )})`,
            },
            producerOfServiceValueId: {
                value: `${_.get(
                    fromAccountLanding,
                    'policyDetailsData.policyResponse.latestPeriod.producerCodeOfServiceOrg'
                )}(${_.get(
                    fromAccountLanding,
                    'policyDetailsData.policyResponse.latestPeriod.producerCodeOfService'
                )})`,
            },
            policySummary:{
                visible:!_.isUndefined(policyDetailsData) &&!_.isEmpty(policyDetailsData) && _.get(policyDetailsData,'latestPeriod.policyLines[0].lineOfBusinessCode')!=='CPLine' && this.props.authUserData.associationName_TWIA!=='tfpa',
                producerOfServiceValue:`${_.get(
                    fromAccountLanding,
                    'policyDetailsData.policyResponse.latestPeriod.producerCodeOfServiceOrg'
                )}(${_.get(
                    fromAccountLanding,
                    'policyDetailsData.policyResponse.latestPeriod.producerCodeOfService'
                )})`,
                producerOfRecordValue:`${_.get(
                    fromAccountLanding,
                    'policyDetailsData.policyResponse.latestPeriod.producerCodeOfRecordOrg'
                )}(${_.get(
                    fromAccountLanding,
                    'policyDetailsData.policyResponse.latestPeriod.producerCodeOfRecord'
                )})`,
                policyDetailsData,
                lobData_TWIA,
                policyTransactionDetails,
                policyTransactionData
            },
            commercialPolicySummary: {
                visible: !_.isUndefined(policyDetailsData) && !_.isEmpty(policyDetailsData) && _.get(policyDetailsData,'latestPeriod.policyLines[0].lineOfBusinessCode') ==='CPLine',
                policyDetailsData,
                producerOfServiceValue:`${_.get(
                    fromAccountLanding,
                    'policyDetailsData.policyResponse.latestPeriod.producerCodeOfServiceOrg'
                )}(${_.get(
                    fromAccountLanding,
                    'policyDetailsData.policyResponse.latestPeriod.producerCodeOfService'
                )})`,
                producerOfRecordValue:`${_.get(
                    fromAccountLanding,
                    'policyDetailsData.policyResponse.latestPeriod.producerCodeOfRecordOrg'
                )}(${_.get(
                    fromAccountLanding,
                    'policyDetailsData.policyResponse.latestPeriod.producerCodeOfRecord'
                )})`
            },
            twiaPolicySummary: {
                visible: !_.isUndefined(policyDetailsData) && !_.isEmpty(policyDetailsData) && _.get(policyDetailsData,'latestPeriod.policyLines[0].lineOfBusinessCode') ==='CPLine',
                lobData_TWIA,
                isQuotePage:false
            },
            detailsSectionId:{
                visible:!_.isUndefined(policyDetailsData) && _.get(policyDetailsData,'latestPeriod.policyLines[0].lineOfBusinessCode')==='CPLine'
            },
            tfpaPolicySummary:{
                visible:!_.isUndefined(policyDetailsData) &&!_.isEmpty(policyDetailsData)  && this.props.authUserData.associationName_TWIA ==='tfpa' ,
                producerOfServiceValue:`${_.get(
                    fromAccountLanding,
                    'policyDetailsData.policyResponse.latestPeriod.producerCodeOfServiceOrg'
                )}(${_.get(
                    fromAccountLanding,
                    'policyDetailsData.policyResponse.latestPeriod.producerCodeOfService'
                )})`,
                producerOfRecordValue:`${_.get(
                    fromAccountLanding,
                    'policyDetailsData.policyResponse.latestPeriod.producerCodeOfRecordOrg'
                )}(${_.get(
                    fromAccountLanding,
                    'policyDetailsData.policyResponse.latestPeriod.producerCodeOfRecord'
                )})`,
                policyDetailsData,
                lobData_TWIA,
                policyTransactionDetails,
                policyTransactionData

            },
            // DE16989
            transactionStatusColumnTitle:{
                visible:this.props.authUserData.associationName_TWIA !=='tfpa'
            },
            transactionStatusColumnTFPATitle:{
                visible:this.props.authUserData.associationName_TWIA ==='tfpa'
            },
            jobNumberColumnTitle:{
                header:this.props.authUserData.associationName_TWIA !=='tfpa'? 'TRANSACTION NUMBER' : 'JOB NUMBER'
            },
            filterDropDownLayout:{
                visible:this.props.authUserData.associationName_TWIA ==='tfpa'
            },
            pageTitleHorizontalLine:{
                columns: this.props.authUserData.associationName_TWIA ==='tfpa'? ["8fr", "1fr","2fr"] :  ["8fr", "2fr"] ,
            },
            tfpaQuestions: {
                visible: policyData.reQualificationNeeded_TFPA === true && !showtfpaRequalQuestionSet,
                policyNumber: policyData.policyNumber,
                policyType: policyData.latestPeriod.policyType,
            },
            policyType: { // DE17489
                value: getPolicyTypeValue(),
            }
            // ...this.generateOverrides(),
        };

        const resolvers = {
            resolveClassNameMap: styles,
            resolveCallbackMap: {
                getCell,
                getJobNumberLink: this.getJobNumberLink,
                onChangePolicy: this.onChangePolicy,
                onRenewalPolicy: this.onRenewalPolicy,
                handleCancelButtonClick: this.handleCancelButtonClick,
                onDoNotCancel: this.onDoNotCancel,
                handleFilterValueChange: this.handleFilterValueChange,
                handleSearchValueChange: this.handleSearchValueChange,
                onDoNotChangePolicy: this.onDoNotChangePolicy,
                sortDate: DatatableUtil.sortDate,
                sortString: DatatableUtil.sortString,
                sortCurrency: DatatableUtil.sortCurrency,
                sortNumber: DatatableUtil.sortNumber,
                handleRequalButtonClick: this.handleRequalButtonClick,
                onRequalSubmit: this.onRequalSubmit,
                handleCancelClick: this.handleCancelClick,
                handlePrivacyPolicyClick: this.handlePrivacyPolicyClick
            },
            resolveComponentMap: {
                cancelcomponent: Cancellation,
                policypacomponent: PolicyVehiclesDriversInfo,
                changepolicycomponent: ChangePolicy,
                policydwellingcomponent: PolicyDwellingInfo,
                coveragesiterablecomponent: CoveragesIterableComponent,
                policySummary:PolicySummary,
                tfpaPolicySummary:TFPAPolicySummary,
                CommercialPolicySummary,
                TWIACommercialPolicySummary,
                questionset: QuestionSetComponent_Ext,
                TFPARenewalRequalSummary,
                PrivacyDisclosure
            }
        };
        const readValue = (id, path) => readViewModelValue(
                metadata.pageContent,
                policyData,
                id,
                path,
                overrides
            );

        return (
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={policyData}
                overrideProps={overrides}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
                resolveValue={readValue}
                onValidationChange={setComponentValidation}
                showErrors= {showErrors}
            />
        );
    }
}

export const SummaryComponent = Summary;
export default  withValidation(withViewModelService(withRouter(withIntl(withAuthenticationContext(withModalContext(Summary))))));
